<script>
  import relatorioTecnicoProjetoServico from '../servico';
  import projetoServico from '~modulos/projeto/servico';

  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';

  import Radio from '~componentes/Radio.vue';
  import Paginacao from '~componentes/Paginacao.vue';
  import DatePicker from 'vue2-datepicker';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';
  import ModalLiberar from '~componentes/ModalLiberarRelatorioTecnicoProjeto.vue';

  export default {
    components: { Paginacao, Radio, DatePicker, ModalArquivosSolicitacao, ModalLiberar },
    data() {
      return {
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        relatoriosTecnico: [],
        carregando: true,
        filtros: this.camposFiltros(),
        projetos: [],
        relatorioTecnicoSelecionado: null,
        modalArquivos: false,
        animated: true,
        configuracao: this.$storage.configuracao(),
        modalLiberar: false,
        salvandoLiberacao: false,
        usuario: this.$storage.usuario(),
      }
    },
    mounted() {
      this.$root.tituloDaPagina = 'Relatório Técnico Projeto - Lista';
      this.$root.botaoAcaoMostrar = false;

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.listaDeProjetos();

      const _this = this;

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
        .change(function (e) {
          _this.$set(_this.filtros, 'idProjeto', this.value);
        });
    },
    methods: {
      camposFiltros() {
        return {
          idProjeto: '0',
          mostrarRelatoriosTecnico: '0',
        };
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => {
          $('#projeto').val(0);
          $('#projeto').trigger('change.select2');
        });

        this.errors.clear();

        this.lista();
      },
      lista(pagina = 1) {
        this.carregando = true;

        return relatorioTecnicoProjetoServico.lista(pagina, this.filtros)
          .then(res => {
            this.carregando = false;

            this.relatoriosTecnico = res.body.registros;
            this.totalRegistros = res.body.totalRegistros;
            this.totalPaginas = res.body.totalPaginas;
            this.registrosPorPagina = res.body.registrosPorPagina;
          });
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.relatorioTecnicoSelecionado = null;
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      mostrarModalArquivos(relatorioTecnico) {
        this.relatorioTecnicoSelecionado = relatorioTecnico;
        this.modalArquivos = true;
      },
      respondido(relatorioTecnico) {
        if (relatorioTecnico.situacao == 5)
          return false;

        return !relatorioTecnico.habilitadoEdicao;
      },
      enviado(relatorioTecnico) {
        if (relatorioTecnico.idResponsavelEnvio > 0)
          return true;

        return !relatorioTecnico.habilitadoEnvio;
      },
      listaDeProjetos() {
        return projetoServico
          .listaProjetosRelatorioTecnico()
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      mostrarModalLiberar(relatorioTecnico) {
        if (!relatorioTecnico.habilitadoEnvio) {
          this.$swal(
            '',
            'Não é possível liberar este relatório técnico projeto. ',
            'info'
          );
          return 1;
        }

        this.relatorioTecnicoSelecionado = relatorioTecnico;
        this.modalLiberar = true;
      },
      modalLiberarFechado() {
        this.animated = false;
        this.modalLiberar = false;
        this.relatorioTecnicoSelecionado = null;
      },
      liberar() {
        this.salvandoLiberacao = true;

        relatorioTecnicoProjetoServico
          .liberar(this.relatorioTecnicoSelecionado.idAcompanhamentoProjeto)
          .then(status => {
            this.modalLiberar = false;

            if (status.liberado) {
              toastr.success(`Relatório técnico projeto #${this.relatorioTecnicoSelecionado.numeroRelatorio} liberado com sucesso.`);
            } else {
              toastr.warning(`Ocorreu um erro ao liberar este relatório técnico`);
            }

            this.salvandoLiberacao = false;
            this.relatorioTecnicoSelecionado = null;

            this.lista()
          })
      },
    },
    created() {
      this.lista(this.pagina);
    },
    watch: {
      '$route': 'lista'
    },
  }
</script>
  
<style>
  .relatoriotecnicook {
    font-size: 1.40em;
    color: #1d9d2d;
    margin-left: 50px;
  }

  .relatoriotecnicoalert {
    font-size: 1.40em;
    color: #a6a915;
    margin-left: 50px;
  }

  .relatoriotecnicoalertred {
    font-size: 1.40em;
    color: #f11919;
    margin-left: 50px;
  }

  .relatoriotecnicodanger {
    font-size: 1.40em;
    color: #f11919;
    margin-left: 50px;
  }

  .relatoriotecnicookg {
    font-size: 1.40em;
    color: #1d9d2d;
  }

  .relatoriotecnicoalertg {
    font-size: 1.40em;
    color: #a6a915;
  }

  .relatoriotecnicoalertredg {
    font-size: 1.40em;
    color: #f11919;
  }

  .relatoriotecnicodangerg {
    font-size: 1.40em;
    color: #f11919;
  }
</style>

<template>

  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">

    <modal-liberar :mostrar="modalLiberar"
                            :id="relatorioTecnicoSelecionado ? relatorioTecnicoSelecionado.idAcompanhamentoProjeto : ''"
                            :numero="relatorioTecnicoSelecionado ? relatorioTecnicoSelecionado.numeroRelatorio : ''"
                            :salvando="salvandoLiberacao"
                            @fechado="modalLiberarFechado"
                            @liberar="liberar">
    </modal-liberar>

    <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                :id="relatorioTecnicoSelecionado ? relatorioTecnicoSelecionado.idAcompanhamentoProjeto : ''"
                                tipo="acompanhamento"
                                @fechado="modalArquivosFechado">
    </modal-arquivos-solicitacao>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox collapsed float-e-margins">
          <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
            <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

            <div class="ibox-tools">
              <span class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </span>
            </div>
          </div>
          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label class="control-label" for="projeto">Projeto</label>

                  <select id="projeto"
                          class="form-control"
                          v-model="filtros.idProjeto">
                    <option value="0">Todos</option>
                    <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-3">
                <div class="form-group">
                  <label class="control-label block">Mostrar relatórios técnicos</label>

                  <radio v-model="filtros.mostrarRelatoriosTecnico"
                         selected-value="0"
                         type="success"
                         :inline="true"
                         class="margin-right-10">
                    Todos
                  </radio>
                  <radio v-model="filtros.mostrarRelatoriosTecnico"
                         selected-value="1"
                         type="success"
                         :inline="true"
                         class="margin-right-10">
                    Pendentes
                  </radio>
                  <radio v-model="filtros.mostrarRelatoriosTecnico"
                         selected-value="2"
                         type="success"
                         :inline="true">
                    Respondidos
                  </radio>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group no-margins">
                  <button type="button" class="btn btn-primary no-margins" @click="lista">
                    <i class="fa fa-search"></i>
                    Filtrar
                  </button>
                  <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                    <i class="fa fa-search"></i>
                    Limpar filtros
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox-footer">
            <div class="alert alert-warning" role="alert" v-show="true">
              <div class="table-responsive">

                <table class="table table-column-code table-column-action">
                  <tr>
                    <td><i class="fa fa-check-circle relatoriotecnicook"></i> Relatório técnico do projeto respondido</td>
                    <td><i class="fa fa-exclamation-triangle relatoriotecnicoalert"></i>  Relatório técnico do projeto em período de preenchimento</td>
                    <td><i class="fa fa-exclamation-triangle relatoriotecnicoalertred"></i>  Relatório técnico do projeto pendente de preenchimento</td>
                    <td><i class="fa fa-times-circle relatoriotecnicodanger"></i>  Relatório técnico do projeto em atraso, projeto bloqueado para fazer solicitações</td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-bordered table-column-code table-column-action">
                <thead>
                  <tr>
                    <th>Situação</th>
                    <th>Nº relatório</th>
                    <th>Projeto</th>
                    <th>Início</th>
                    <th>Fim</th>
                    <th>Data limite</th>
                    <th>Bloqueio</th>
                    <th>Pessoa responsável pelas respostas</th>
                    <th>Respondido em...</th>
                    <th>Código</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(relatorioTecnico, index) in relatoriosTecnico">
                    <td>
                      <i class="fa fa-times-circle relatoriotecnicodangerg" v-if="relatorioTecnico.situacao == 1"></i>
                      <i class="fa fa-exclamation-triangle relatoriotecnicoalertredg" v-if="relatorioTecnico.situacao == 2"></i>
                      <i class="fa fa-exclamation-triangle relatoriotecnicoalertg" v-if="relatorioTecnico.situacao == 3"></i>
                      <i class="fa fa-check-circle relatoriotecnicookg" v-if="relatorioTecnico.situacao == 5"></i>
                    </td>
                    <td>{{ relatorioTecnico.numeroRelatorio || '---' }}</td>
                    <td>{{ relatorioTecnico.nomeProjeto || '---' }}</td>
                    <td>{{ relatorioTecnico.periodoRelatorioInicio || '---' }}</td>
                    <td>{{ relatorioTecnico.periodoRelatorioFim || '---' }}</td>
                    <td>{{ relatorioTecnico.previsaoConclusao || '---' }}</td>
                    <td>{{ relatorioTecnico.dataBloqueio || '---' }}</td>
                    <td>{{ relatorioTecnico.responsavelEnvio || '---' }}</td>
                    <td>{{ relatorioTecnico.dataEnvio | formatarData }} - {{ relatorioTecnico.dataEnvio | formatarHora }}</td>
                    <td>{{ relatorioTecnico.idAcompanhamentoProjeto || '---' }}</td>
                    <td>
                      <router-link tag="button"
                                   :disabled="respondido(relatorioTecnico)"
                                   class="btn btn-secondary btn-xs"
                                   active-class=""
                                   v-tooltip="'Responder'"
                                   :to="{ name: 'relatorio-tecnico-projeto.editar', params: { id: relatorioTecnico.idAcompanhamento, idrelatorioTecnico: relatorioTecnico.idAcompanhamentoProjeto, numeroRelatorio : relatorioTecnico.numeroRelatorio  } }">
                        <i class="fa fa-pencil"></i>
                      </router-link>

                      <button type="button"
                              class="btn btn-info btn-xs"
                              :disabled="respondido(relatorioTecnico)"
                              v-tooltip="'Listar ou adicionar arquivos do relatório técnico'"
                              @click="mostrarModalArquivos(relatorioTecnico)"
                              v-if="configuracao.pastaBaseAcompanhamentoProjeto !==''">
                        <i class="fa fa-archive"></i>
                      </button>

                      <router-link tag="button"
                                   class="btn btn-success btn-xs"
                                   :disabled="respondido(relatorioTecnico)"
                                   active-class=""
                                   v-tooltip="'Plano trabalho'"
                                   :to="{ name: 'relatorio-tecnico-projeto.planotrabalho', params: { id: relatorioTecnico.idAcompanhamento, idrelatorioTecnico: relatorioTecnico.idAcompanhamentoProjeto, idResponsavelEnvio : relatorioTecnico.idResponsavelEnvio, numeroRelatorio : relatorioTecnico.numeroRelatorio  } }">
                        <i class="fa fa-bars"></i>
                      </router-link>

                      <router-link tag="button"
                                   v-if="relatorioTecnico.preecherEquipeRelatorioTecnico"
                                   class="btn btn-warning btn-xs"
                                   :disabled="respondido(relatorioTecnico)"
                                   active-class=""
                                   v-tooltip="'Plano trabalho equipe'"
                                   :to="{ name: 'relatorio-tecnico-projeto.planotrabalhoequipe', params: { id: relatorioTecnico.idAcompanhamento, idrelatorioTecnico: relatorioTecnico.idAcompanhamentoProjeto, numeroRelatorio : relatorioTecnico.numeroRelatorio  } }">
                          <i class="fa fa-address-book-o"></i>
                      </router-link>

                      <router-link tag="button"
                                   class="btn btn-info btn-xs"
                                   :disabled="respondido(relatorioTecnico)"
                                   active-class=""
                                   v-tooltip="'Plano trabalho aquisições'"
                                   :to="{ name: 'relatorio-tecnico-projeto.planotrabalhoaquisicoes', params: { id: relatorioTecnico.idAcompanhamento, idrelatorioTecnico: relatorioTecnico.idAcompanhamentoProjeto, numeroRelatorio : relatorioTecnico.numeroRelatorio  } }">
                        <i class="fa fa-shopping-cart"></i>
                      </router-link>

                      <button v-if="!configuracao.usoEmailLiberarSolicitacao && usuario.id == relatorioTecnico.idCoordenador"
                              :disabled="enviado(relatorioTecnico)"
                              class="btn btn-success btn-xs"
                              v-tooltip="'Liberar relatório técnico'"
                              @click="mostrarModalLiberar(relatorioTecnico)">
                        <i class="fa fa-check"></i>
                      </button>

                    </td>
                  </tr>
                  <tr v-show="carregando">
                    <td colspan="9">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <paginacao :page-count="totalPaginas"
                       :click-handler="lista"
                       :per-page="registrosPorPagina"
                       :register-count="totalRegistros"
                       :show-counter="true">
            </paginacao>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio-tecnico-projeto/componentes/RelatorioTecnicoProjetoLista.vue